import { ActionFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined } from '@hsp/utilities';

import { authenticationService } from 'services';
import { IUserLogin } from 'types/user';
import { s } from 'utilities/strings';

export const loginAction = (_: QueryClient) => {
  return async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const loginRequest: Record<string, string> = {};

    formData.forEach((value, key) => (loginRequest[key] = value as string));

    try {
      const response = await authenticationService.login(loginRequest as unknown as IUserLogin);

      if (!isDefined(response)) {
        throw new Error(s('Api.UnknownError'));
      }

      return response;
    } catch (e) {
      return { error: e instanceof Error ? e : new Error(e?.toString()) };
    }
  };
};
